import {Timeout} from "../common/const";

export const initPopup = () => {
    // открыть попап при наведении на ссылку
    $(`[data-popup-show]`).on( "mouseenter", function(e) {
        const $target = $(e.target);
        const attr = $target.attr(`data-popup-show`);
        const $popup = $(`.popup[data-popup=${attr}]`);
        var leftx = e.pageX - $popup[0].offsetLeft - ($popup.outerWidth(true) / 2);
        var topy = e.pageY - $popup[0].offsetTop;

        // $popup.css({
        //     top: topy,
        //     bottom: `auto`,
        //     left: leftx,
        //     right: `auto`,
        // });

        $popup.fadeIn(Timeout.ANIMATION_TOGGLE);

        setTimeout(() => {
            $popup.addClass(`active`);
        }, Timeout.ANIMATION_TOGGLE)
    })

    // закрыть попап при уведении с попапа
    $(window).on(`mouseenter`, function(e) {
        const div = $(`[data-popup].active`);
        const attr = div.attr(`data-popup`);
        const link = $(`[data-popup-show=${attr}]`);

        if (!div.is(e.target) && div.has(e.target).length === 0 && !link.is(e.target)) {
            div.fadeOut(Timeout.ANIMATION_TOGGLE);
        }
    });

    // закрыть попап по клику на крестик
    $(`body`).on(`click`, `[data-popup-close]`, function(e) {
        $(this).closest(`.popup`).fadeOut(Timeout.ANIMATION_TOGGLE);
    });
}
